import axios, { AxiosError } from 'axios';
import type { QueryClient } from '@tanstack/react-query';

let _queryClient: QueryClient | null = null;

export function setQueryClient(qc: QueryClient): void {
  _queryClient = qc;
}

const api = axios.create({
  baseURL: '/api',
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Public paths that should not clear auth state on 401
const EXACT_PUBLIC_PATHS = ['/login', '/register', '/forgot-password', '/reset-password'];
const PREFIX_PUBLIC_PATHS = ['/share/', '/kb/share/'];

// Response interceptor for error handling
api.interceptors.response.use(
  (response) => response,
  (error: AxiosError<{ error?: string; code?: string }>) => {
    const message = error.response?.data?.error || error.message || 'An error occurred';
    const code = error.response?.data?.code;

    // Handle 401 errors - clear auth cache so PrivateRoute redirects declaratively
    if (error.response?.status === 401) {
      const pathname = window.location.pathname;
      const isPublicPath = EXACT_PUBLIC_PATHS.includes(pathname) ||
        PREFIX_PUBLIC_PATHS.some(prefix => pathname.startsWith(prefix));

      if (!isPublicPath && _queryClient) {
        _queryClient.setQueryData(['auth', 'me'], null);
      }
    }

    const err: Error & { code?: string } = new Error(message);
    if (code) {
      err.code = code;
    }
    return Promise.reject(err);
  }
);

export default api;
